<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn v-if="page.isNew" id="btnSave" type="button" elevation="0" color="primary" dark
                            @click="add" :loading="dataset.loading">Salvar</v-btn>
                        <v-btn v-else id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
                            :loading="dataset.loading">Salvar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/empresas">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card style="padding: 20px" class="card-form-outlined">
                                <v-row class="mb-2">
                                    <v-col>
                                        <span class="font-weight-bold">Detalhes</span>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="6">
                                        <v-text-field dense outlined id="name" v-model="dataset.data.name"
                                            label="Nome/Razão Social" hide-details="auto" required></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="6">
                                        <v-text-field dense outlined id="registration"
                                            v-model="dataset.data.registration" label="IE/RG" hide-details="auto"
                                            required></v-text-field>
                                    </v-col>

                                    <v-col cols="6">
                                        <v-text-field dense id="identification" label="CPF/CNPJ"
                                            v-model="dataset.data.identification"
                                            v-mask="dataset.data.identification && dataset.data.identification.length == 11 ? this.$masks.cpf : this.$masks.cnpj"
                                            :rules="[$rules.required]" outlined hide-details="auto"
                                            required></v-text-field>
                                    </v-col>

                                </v-row>

                                <v-row>
                                    <v-col cols="6">
                                        <v-text-field dense outlined id="cellphone" v-model="dataset.data.phone_number"
                                            hide-details="auto" label="Celular"></v-text-field>
                                    </v-col>

                                    <v-col cols="6">
                                        <v-text-field dense outlined id="email" v-model="dataset.data.email"
                                            label="E-mail" hide-details="auto" type="email"></v-text-field>
                                    </v-col>
                                </v-row>

                            </v-card>

                            <v-card style="padding: 20px; margin-top: 10px" class="card-form-outlined">

                                <v-row class="mb-2">
                                    <v-col>
                                        <span class="font-weight-bold">Endereços</span>
                                    </v-col>
                                </v-row>

                                <span style="padding: 16px; color:rgb(158 158 158) "
                                    v-if="!dataset.data.addresses || !dataset.data.addresses.length">Nenhum
                                    endereço adicionado</span>

                                <v-expansion-panels>
                                    <v-expansion-panel v-for="(address, index) in dataset.data.addresses" :key="index">
                                        <v-expansion-panel-header>
                                            <v-row align="center">
                                                <v-col>
                                                    <span>
                                                        Endereço #{{ index + 1 }} - {{ address.name || 'Novo Endereço'
                                                        }}
                                                    </span>
                                                </v-col>

                                                <v-spacer></v-spacer>

                                                <v-col cols="1">
                                                    <template>
                                                        <v-tooltip bottom>
                                                            <template #activator="{ on }">
                                                                <v-btn icon v-on="on" @click.stop="removeAddress(index)"
                                                                    size="large" color="error">
                                                                    <v-icon>mdi-delete</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>
                                                                Remover endereço
                                                            </span>
                                                        </v-tooltip>
                                                    </template>
                                                </v-col>
                                            </v-row>

                                        </v-expansion-panel-header>

                                        <v-expansion-panel-content class="pt-4">
                                            <v-row>
                                                <v-col cols="3">
                                                    <v-text-field dense outlined v-model="address.name" label="Nome"
                                                        hide-details="auto"></v-text-field>
                                                </v-col>
                                                <v-col>
                                                    <v-autocomplete dense outlined :items="dataset.addresses[index]"
                                                        :loading="dataset.loadingAddress === index"
                                                        v-model="dataset.data.addresses[index].address"
                                                        item-value="placeId" item-text="address" return-object
                                                        hide-details="auto"
                                                        @update:search-input="val => getAddressByType(val, index)"
                                                        :filter="() => true" @change="onAddressSelected(index, $event)">
                                                        <!-- <template v-slot:item="{ item }">
                                                            <div class="py-2 d-flex flex-column">
                                                                <span class="text--secondary text-caption">{{
                                                                    item.address }}</span>
                                                            </div>
                                                        </template>

                                                        <template v-slot:selection="{ item }">
                                                            <span>{{ item.address }}</span>
                                                        </template> -->
                                                    </v-autocomplete>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="3">
                                                    <v-text-field dense outlined v-model="address.city" disabled
                                                        label="Cidade"></v-text-field>
                                                </v-col>
                                                <v-col cols="3">
                                                    <v-text-field dense outlined v-model="address.state" disabled
                                                        label="Estado"></v-text-field>
                                                </v-col>
                                                <v-col cols="3">
                                                    <v-text-field dense outlined v-model="address.latitude"
                                                        label="Latitude"></v-text-field>
                                                </v-col>
                                                <v-col cols="3">
                                                    <v-text-field dense outlined v-model="address.longitude"
                                                        label="Longitude"></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>


                                <v-btn class="mt-10" dense id="btnSave" type="button" elevation="0" color="primary" dark
                                    @click="addAddress">Adicionar
                                    Endereço</v-btn>
                            </v-card>

                            <v-card style="padding: 20px; margin-top: 10px" class="card-form-outlined">
                                <v-row class="mb-2">
                                    <v-col>
                                        <span class="font-weight-bold">Configurações</span>
                                    </v-col>
                                </v-row>

                                <v-row dense>
                                    <v-col cols="6">
                                        <v-text-field dense outlined v-model="dataset.data.revenue_day"
                                            label="Dia de Faturamento" type="number" min="1" max="31"
                                            required></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field dense outlined v-model="dataset.data.fee_service"
                                            label="Taxa para Serviço" type="number" required></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row dense>
                                    <v-col cols="4">
                                        <v-currency-field label="Adicional por Localidade Extra" dense
                                            v-model="dataset.data.extra_local_value" prefix="R$" :allowNegative=false
                                            hide-details="auto" outlined>
                                        </v-currency-field>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-currency-field label="Valor hora parada" dense
                                            v-model="dataset.data.stop_time" prefix="R$" :allowNegative=false
                                            hide-details="auto" outlined>
                                        </v-currency-field>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field dense outlined v-model="dataset.data.holiday_value"
                                            label="Valor Feriado (%)" type="number" required></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row dense>
                                    <v-col cols="6">
                                        <v-text-field dense outlined v-model="dataset.data.start_time" type="time"
                                            label="Horário Início"
                                            placeholder="Informe um horário de início"></v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field dense outlined v-model="dataset.data.end_time" type="time"
                                            label="Horário Final"
                                            placeholder="Informe um horário de término"></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row dense>
                                    <v-col cols="12">
                                        <v-checkbox v-model="dataset.data.exclude_toll_from_trip_total"
                                            label="Não incluir pedágio no total da viagem exportado"
                                            hint="O pedágio continua aparecendo no relatório, mas separado do total da viagem."
                                            persistent-hint hide-details="auto"></v-checkbox>
                                    </v-col>
                                </v-row>

                                <v-subheader class="pl-0 font-weight-bold">Aprovação automática</v-subheader>

                                <template v-if="dataset.data.auto_approval_rules.length">
                                    <v-row dense v-for="(item, index) in dataset.data.auto_approval_rules">
                                        <v-col cols="4">
                                            <v-select label="Dias da semana" multiple outlined dense
                                                :items="dataset.weekDays" item-value="id" item-text="label"
                                                v-model="item.days"></v-select>
                                        </v-col>
                                        <v-col cols="3">
                                            <v-text-field dense outlined v-model="item.start" type="time"
                                                label="Horário Início"
                                                placeholder="Informe um horário de início"></v-text-field>
                                        </v-col>
                                        <v-col cols="3">
                                            <v-text-field dense outlined v-model="item.end" type="time"
                                                label="Horário Final"
                                                placeholder="Informe um horário de término"></v-text-field>
                                        </v-col>
                                        <v-col cols="2">
                                            <v-tooltip bottom>
                                                <template #activator="{ on }">
                                                    <v-btn icon v-on="on" @click.stop="removeAutoApprovalRule(index)"
                                                        size="large" color="error">
                                                        <v-icon>mdi-delete</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>
                                                    Remover regra
                                                </span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                                </template>

                                <v-row v-else>
                                    <v-col>
                                        <span class="text-body-2">Nenhuma regra de aprovação automática
                                            encontrada.</span>
                                    </v-col>
                                </v-row>

                                <v-row dense>
                                    <v-col>
                                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark
                                            @click="addAutoApprovalRule">Adicionar</v-btn>
                                    </v-col>
                                </v-row>

                                <v-subheader class="mt-10 pl-0 font-weight-bold">Cobrança extra</v-subheader>

                                <template v-if="dataset.data.extra_charge_rules.length">
                                    <v-row dense v-for="(item, index) in dataset.data.extra_charge_rules">
                                        <v-col cols="4">
                                            <v-select label="Dias da semana" multiple outlined dense
                                                :items="dataset.weekDays" item-value="id" item-text="label"
                                                v-model="item.days"></v-select>
                                        </v-col>
                                        <v-col cols="2">
                                            <v-text-field dense outlined v-model="item.start" type="time"
                                                label="Horário Início"
                                                placeholder="Informe um horário de início"></v-text-field>
                                        </v-col>
                                        <v-col cols="2">
                                            <v-text-field dense outlined v-model="item.end" type="time"
                                                label="Horário Final"
                                                placeholder="Informe um horário de término"></v-text-field>
                                        </v-col>
                                        <v-col cols="2">
                                            <v-text-field dense outlined v-model="item.extra_percent"
                                                label="Valor extra (%)" type="number" required></v-text-field>
                                        </v-col>
                                        <v-col cols="2">
                                            <v-tooltip bottom>
                                                <template #activator="{ on }">
                                                    <v-btn icon v-on="on" @click.stop="removeExtraChargeRule(index)"
                                                        size="large" color="error">
                                                        <v-icon>mdi-delete</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>
                                                    Remover regra
                                                </span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                                </template>

                                <v-row v-else>
                                    <v-col>
                                        <span class="text-body-2">Nenhuma regra de cobrança extra
                                            encontrada.</span>
                                    </v-col>
                                </v-row>

                                <v-row dense>
                                    <v-col>
                                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark
                                            @click="addExtraChargeRule">Adicionar</v-btn>
                                    </v-col>
                                </v-row>

                                <v-subheader class="mt-10 pl-0 font-weight-bold">Configurações da solicitação</v-subheader>
                                <span class="text-body-2 grey--text">Campos exibidos ao solicitante no painel do cliente.</span>

                                <v-row dense class="mt-2" v-for="field in settingsFields" :key="`setting-${field.key}`">
                                    <v-col cols="3" class="d-flex align-center">
                                        <span class="font-weight-medium">{{ field.label }}</span>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-switch dense inset hide-details class="mt-0" label="Exibir"
                                            v-model="dataset.data.settings.trip_request[field.key].enabled"></v-switch>
                                    </v-col>
                                    <v-col cols="3" v-if="field.canRequire">
                                        <v-switch dense inset hide-details class="mt-0" label="Obrigatório"
                                            :disabled="!dataset.data.settings.trip_request[field.key].enabled"
                                            v-model="dataset.data.settings.trip_request[field.key].required"></v-switch>
                                    </v-col>
                                    <v-col cols="3" v-if="field.key === 'justification'">
                                        <v-text-field dense outlined hide-details="auto" type="number" min="0"
                                            label="Mínimo de caracteres"
                                            :disabled="!dataset.data.settings.trip_request.justification.enabled"
                                            v-model.number="dataset.data.settings.trip_request.justification.min_length"></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-subheader class="mt-10 pl-0 font-weight-bold">Pontos de parada</v-subheader>

                                <v-row dense>
                                    <v-col cols="3">
                                        <v-switch dense inset hide-details class="mt-0" label="Habilitar pontos de parada"
                                            v-model="dataset.data.settings.stops.enabled"></v-switch>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-switch dense inset hide-details class="mt-0" label="Solicitante pode cadastrar"
                                            :disabled="!dataset.data.settings.stops.enabled"
                                            v-model="dataset.data.settings.stops.allow_requester"></v-switch>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-text-field dense outlined hide-details="auto" type="number" min="1" max="20"
                                            label="Máximo de paradas por viagem"
                                            :disabled="!dataset.data.settings.stops.enabled"
                                            :rules="[v => !dataset.data.settings.stops.enabled || (v >= 1 && v <= 20) || 'Entre 1 e 20']"
                                            v-model.number="dataset.data.settings.stops.max"></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-subheader class="mt-10 pl-0 font-weight-bold">Logística</v-subheader>

                                <v-row dense>
                                    <v-col cols="3">
                                        <v-text-field dense outlined hide-details="auto" type="number" min="0" max="180"
                                            label="Margem antes da entrada (min)" suffix="min"
                                            hint="Entrada às 18:00 com 15 min: o carro chega às 17:45" persistent-hint
                                            :rules="[v => (v >= 0 && v <= 180) || 'Entre 0 e 180']"
                                            v-model.number="dataset.data.settings.logistics.arrival_margin_minutes"></v-text-field>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-text-field dense outlined hide-details="auto" type="number" min="0" max="30" step="0.5"
                                            label="Espera por passageiro (min)" suffix="min"
                                            hint="Tempo em cada embarque; usado no Gerar horários e na otimização da rota" persistent-hint
                                            :rules="[v => (v >= 0 && v <= 30) || 'Entre 0 e 30']"
                                            v-model.number="dataset.data.settings.logistics.boarding_wait_minutes"></v-text-field>
                                    </v-col>
                                </v-row>

                                <template v-if="dataset.data.settings.trip_request.reason.enabled">
                                <v-subheader class="mt-10 pl-0 font-weight-bold">Motivos personalizados</v-subheader>

                                <template v-if="dataset.data.justifications.length">
                                    <v-row dense v-for="(item, index) in dataset.data.justifications" :key="`justification-${index}`">
                                        <v-col cols="10">
                                            <v-text-field dense outlined v-model="item.name"
                                                label="Motivo" hide-details="auto"
                                                :rules="[$rules.required]"></v-text-field>
                                        </v-col>
                                        <v-col cols="2">
                                            <v-tooltip bottom>
                                                <template #activator="{ on }">
                                                    <v-btn icon v-on="on" @click.stop="removeJustification(index)"
                                                        size="large" color="error">
                                                        <v-icon>mdi-delete</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>
                                                    Remover motivo
                                                </span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                                </template>

                                <v-row v-else>
                                    <v-col>
                                        <span class="text-body-2">Nenhum motivo personalizado. O solicitante verá a lista padrão.</span>
                                    </v-col>
                                </v-row>

                                <v-row dense>
                                    <v-col>
                                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark
                                            @click="addJustification">Adicionar</v-btn>
                                    </v-col>
                                </v-row>
                                </template>

                                <!-- <v-row>
                                <v-col cols="6">
                                    <v-text-field dense outlined id="porcentagemIntervalo" v-model="dataset.submit.porcentagemIntervalo" label="Informe a Porcentagem" type="number"></v-text-field>
                                </v-col>
                            </v-row> -->

                            </v-card>

                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>

    </v-container>
</template>

<script>
import string from "@/common/util/string"
import object from "@/common/util/object"

import debounce from 'lodash/debounce'
import merge from 'lodash/merge'
import cloneDeep from 'lodash/cloneDeep'

import axios from "axios"

// Espelha os padrões de app/Support/CustomerSettings.js (backend)
const DEFAULT_SETTINGS = {
    trip_request: {
        reason: { enabled: true, required: true },
        justification: { enabled: true, required: true, min_length: 20 },
        observation: { enabled: true }
    },
    stops: {
        enabled: false,
        max: 5,
        allow_requester: true
    },
    logistics: {
        arrival_margin_minutes: 15,
        boarding_wait_minutes: 2
    }
}

export default {
    name: "CustomerDetails",
    data: () => ({
        page: {
            title: "",
            isNew: true
        },
        dataset: {
            data: {
                identification: '',
                addresses: [],
                auto_approval_rules: [],
                extra_charge_rules: [],
                justifications: [],
                exclude_toll_from_trip_total: false,
                settings: cloneDeep(DEFAULT_SETTINGS)
            },
            weekDays: [
                { id: 0, label: 'Domingo' },
                { id: 1, label: 'Segunda' },
                { id: 2, label: 'Terça' },
                { id: 3, label: 'Quarta' },
                { id: 4, label: 'Quinta' },
                { id: 5, label: 'Sexta' },
                { id: 6, label: 'Sábado' }
            ],
            breadcrumbItems: [],
            loading: false,
            loadingAddress: null,
            submit: {
                brand: null,
                enderecos: [],
                email: ""
            },
            addresses: [],
        },
        enderecos: [],
        searchAddress: [],
        addressSessionTokens: {},
        dataForm: {
            validForm: true,
        },
    }),

    created() {
        this.loadData();
    },

    computed: {
        filteredModels() {
            if (!this.dataset.submit.brand) return [];
            return vehicleCarModelsData.filter(model => model.make === this.dataset.submit.brand);
        },
        emailMask() {
            return email => email.replace(/[^a-zA-Z0-9@._-]/g, '');
        },
        settingsFields() {
            return [
                { key: 'reason', label: 'Motivo', canRequire: true },
                { key: 'justification', label: 'Justificativa', canRequire: true },
                { key: 'observation', label: 'Observação', canRequire: false }
            ];
        },
    },

    methods: {
        goBack() {
            this.$router.replace("/empresas");
        },

        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();

            await this.load();
        },

        setPage() {
            this.page.isNew = this.$route.params.id == 'novo'
            this.page.title = this.page.isNew ? "Novo empresa" : "Detalhes do empresa";
        },

        filterByNameOrAddress(item, queryText, itemText) {
            if (!queryText) return true
            const q = this._norm(queryText)
            return this._norm(item.name).includes(q) || this._norm(item.address).includes(q)
        },
        _norm(s) {
            return (s || '')
                .normalize('NFD') // remove acentos
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase()
                .trim()
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Empresas",
                disabled: false,
                to: "/empresas",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.isNew ? "Novo empresa" : "Detalhes do empresa",
                disabled: true,
                exact: true,
            });
        },

        async load() {
            if (this.page.isNew) return;

            this.dataset.loading = true;

            try {
                const result = await axios.get(`/api/v2/customers/${this.$route.params.id}`);


                this.dataset.addresses = result.data.content.addresses.map((addr, index) => [{
                    placeId: addr.iid,
                    address: addr.address
                }]);

                let autoApprovalRules = this.parseJsonArray(result.data.content.auto_approval_rules);
                let extraChargeRules = this.parseJsonArray(result.data.content.extra_charge_rules);
                let justifications = this.parseJsonArray(result.data.content.justifications);

                this.dataset.data = {
                    ...result.data.content,
                    auto_approval_rules: autoApprovalRules,
                    extra_charge_rules: extraChargeRules,
                    justifications: justifications,
                    exclude_toll_from_trip_total: this.parseBoolean(result.data.content.exclude_toll_from_trip_total),
                    settings: this.parseSettings(result.data.content.settings)
                };

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            } finally {
                this.dataset.loading = false;
            }
        },

        getAddressByType: debounce(async function (val, index) {
            if (!val || String(val).trim().length < 3) {
                this.$set(this.addressSessionTokens, index, null);
                return;
            }

            if (!this.addressSessionTokens[index]) {
                this.$set(this.addressSessionTokens, index, (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : `${Date.now()}${Math.random()}`);
            }

            this.dataset.loadingAddress = index;

            try {
                const response = await axios.get(`/api/v2/google-maps/find/${encodeURIComponent(val)}`, {
                    params: { sessiontoken: this.addressSessionTokens[index] }
                });

                const results = response.data.content.map(x => ({
                    address: x.address,
                    iid: x.placeId
                }));

                this.$set(this.dataset.addresses, index, results);

            } catch (error) {
                console.error(`Erro ao buscar endereço [${index}]:`, error);
            } finally {
                this.dataset.loadingAddress = null;
            }
        }, 500),

        async getCoordsFromPlaceId(placeId, index = null) {
            try {
                const response = await axios.get(`/api/v2/google-maps/place-details/${placeId}`, {
                    params: index !== null && this.addressSessionTokens[index]
                        ? { sessiontoken: this.addressSessionTokens[index] }
                        : {}
                });

                const { coordinates, city, state } = response.data.content;

                return {
                    latitude: coordinates.lat,
                    longitude: coordinates.lng,
                    city,
                    state
                };
            } catch (error) {
                console.error('Erro ao buscar coordenadas:', error);
                return null;
            }
        },

        async onAddressSelected(index, addressObj) {
            const location = await this.getCoordsFromPlaceId(addressObj.iid, index);

            if (!location) return;

            this.dataset.data.addresses[index].iid = addressObj.iid;
            this.dataset.data.addresses[index].address = addressObj.address;
            this.dataset.data.addresses[index].latitude = location.latitude
            this.dataset.data.addresses[index].longitude = location.longitude;
            this.dataset.data.addresses[index].city = location.city
            this.dataset.data.addresses[index].state = location.state
            this.$set(this.addressSessionTokens, index, null);
        },

        addAddress() {
            this.dataset.data.addresses.push({ iid: '', name: '', state: '', city: '', latitude: '', longitude: '' });
        },

        removeAddress(index) {
            this.dataset.data.addresses.splice(index, 1);
        },

        async add() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja salvar o empresa?',
                title: 'Salvar empresa',
                actions: {
                    false: 'Cancelar',
                    true: 'Salvar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.post(`/api/v2/customers`, payload, { config: { headers: { "Content-Type": "application/json" } } });

                this.$dialog.notify.info("Empresa salvo com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar o empresa?',
                title: 'Atualizar empresa',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.patch(`/api/v2/customers/${this.$route.params.id}`, payload, { config: { headers: { "Content-Type": "application/json" } } });

                this.$dialog.notify.info("Empresa atualizado com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        buildPayload() {
            const data = {
                name: this.dataset.data.name,
                email: this.dataset.data.email,
                identification: string.sanitizeCpfCnpj(this.dataset.data.identification),
                registration: this.dataset.data.registration,
                revenue_day: this.dataset.data.revenue_day,
                fee_service: this.dataset.data.fee_service,
                extra_local_value: this.dataset.data.extra_local_value,
                holiday_value: this.dataset.data.holiday_value,
                stop_time: this.dataset.data.stop_time,
                start_time: this.dataset.data.start_time,
                end_time: this.dataset.data.end_time,
                exclude_toll_from_trip_total: !!this.dataset.data.exclude_toll_from_trip_total,
                address: this.dataset.data.addresses,
                auto_approval_rules: this.dataset.data.auto_approval_rules,
                extra_charge_rules: this.dataset.data.extra_charge_rules,
                justifications: this.dataset.data.justifications,
                settings: this.normalizeSettings(this.dataset.data.settings)
            }

            return data;
        },

        addAutoApprovalRule() {
            this.dataset.data.auto_approval_rules.push({ days: [], start: "", end: "" })
        },

        removeAutoApprovalRule(index) {
            this.dataset.data.auto_approval_rules.splice(index, 1);
        },

        addExtraChargeRule() {
            this.dataset.data.extra_charge_rules.push({ days: [], start: "", end: "", extra_percent: 0 })
        },

        removeExtraChargeRule(index) {
            this.dataset.data.extra_charge_rules.splice(index, 1);
        },

        addJustification() {
            const id = `custom-${Date.now()}-${this.dataset.data.justifications.length + 1}`;

            this.dataset.data.justifications.push({ id, name: "" })
        },

        removeJustification(index) {
            this.dataset.data.justifications.splice(index, 1);
        },

        normalizeSettings(settings) {
            const normalized = cloneDeep(settings);

            normalized.trip_request.justification.min_length = Math.max(0, parseInt(normalized.trip_request.justification.min_length, 10) || 0);
            normalized.stops.max = Math.min(20, Math.max(1, parseInt(normalized.stops.max, 10) || DEFAULT_SETTINGS.stops.max));

            const margin = parseInt(normalized.logistics.arrival_margin_minutes, 10);
            const wait = parseFloat(normalized.logistics.boarding_wait_minutes);
            normalized.logistics.arrival_margin_minutes = Number.isFinite(margin) ? Math.min(180, Math.max(0, margin)) : DEFAULT_SETTINGS.logistics.arrival_margin_minutes;
            normalized.logistics.boarding_wait_minutes = Number.isFinite(wait) ? Math.min(30, Math.max(0, wait)) : DEFAULT_SETTINGS.logistics.boarding_wait_minutes;

            return normalized;
        },

                parseSettings(value) {
            let saved = value;

            if (typeof saved === 'string') {
                try {
                    saved = JSON.parse(saved);
                } catch (error) {
                    saved = null;
                }
            }

            return merge(cloneDeep(DEFAULT_SETTINGS), saved || {});
        },

        parseBoolean(value) {
            return value === true || value === 1 || value === '1';
        },

        parseJsonArray(value) {
            if (Array.isArray(value)) return value;
            if (!value) return [];

            try {
                const parsed = JSON.parse(value);
                return Array.isArray(parsed) ? parsed : [];
            } catch (error) {
                return [];
            }
        }

    },
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}
</style>
